import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  InvoicedNotApprovedCriteriaBean,
  InvoicedNotApprovedListRequest,
  RestPageListBean,
} from "../ds/ds.js";
import { AddIcon,  } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class InvoicedAndNotApprovedList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Invoiced And NotApproved List Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new InvoicedNotApprovedCriteriaBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowLineTable: false,
      detailDataList: [],
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowInvoiceModule: false,
      isShowInvoiceCodeModule: false,
      isShowFabricStyleModule: false,
      isShowPickTicketModule: false,
      isDisableFields: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.salesRepresentativeCode = "admin";
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1
    );
    const lastDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth() + 1,
      0
    );
    criteria.fromInvoiceDate = firstDay;
    criteria.toInvoiceDate = currentDay;
    this.setState({ criteria: criteria });
    ModuleUtils.getInvoiceStatusList();
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let temp_criteria = this.state.criteria;
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadInvoicedNotApprovedListInquiryList(criteria);
  };
  loadInvoicedNotApprovedListInquiryList = (criteria) => {
    if (SecurityAccessManager.InvoicedNotApprovedListInquiry_IsAccessible()) {
      ReportService.inquireInvoicedNotApprovedList(
        criteria,
        this.loadInvoicedNotApprovedListPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadInvoicedNotApprovedListPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let resultList = [];
      if (!isEmptyArray(response.data.result.invoicesInfoList)) {
        resultList = response.data.result.invoicesInfoList;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: resultList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new InvoicedNotApprovedCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.salesRepresentativeCode = "admin";
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1
    );
    const lastDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth() + 1,
      0
    );
    criteria.fromInvoiceDate = firstDay;
    criteria.toInvoiceDate = currentDay;
    this.setState({
      criteria: criteria,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new InvoicedNotApprovedCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.salesRepresentativeCode = "admin";
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1
    );
    const lastDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth() + 1,
      0
    );
    criteria.fromInvoiceDate = firstDay;
    criteria.toInvoiceDate = currentDay;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new InvoicedNotApprovedListRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.InvoicedNotApprovedListInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateInvoicedNotApprovedListReport(
          listRequest,
          this.generateInvoicedNotApprovedListPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.InvoicedNotApprovedListInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateInvoicedNotApprovedListReport(
          listRequest,
          this.generateInvoicedNotApprovedListPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateInvoicedNotApprovedListPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  openLine = (e, invoice, list) => {
    if (e.detail === 1) {
      let detailDataList = [];
      detailDataList = list.itemInfos;
      this.setState({
        isShowLineTable: true,
        detailDataList: detailDataList,
      });
    }
  };
  viewPickTicketModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPickTicketModule: true,
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          isShowPopup: false,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricStyleModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceCodeModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceCodeModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowInvoiceCodeModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowSalesModule: isOpen,
      isShowPickTicketModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLineTable: isShowPopup,
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", <AddIcon />, false)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
        .setClickDetails(true, true, this.openLine, <AddIcon />)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Po#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickTicket#", "pickTicketNumber", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewPickTicketModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CSR", "salesRepresentativeCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setStatusDetails(true, this.getCaption)
    );
    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getInvoiceStatusCaption(status);
  };

  lineDetailColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewInvoiceCodeModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Line#", "invoiceLineNumber", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item " : "FabricStyle#", "fabricStyleCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricStyleModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("color", "colorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "totalShippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let detailDataList = this.state.detailDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          criteria={this.state.criteria}
          onChange={this.onChange}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceCodeModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLineTable}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Line Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <div className="mt-3">
                <CustomTable
                  data={detailDataList}
                  columns={this.lineDetailColumns()}
                />
              </div>
            </div>
          }
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
      </div>
    );
  }
}

class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
    };
    this.salesRepresentativeCodeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.salesRepresentativeCodeRef.current != null) {
      this.salesRepresentativeCodeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>CSR</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.salesRepresentativeCodeRef}
              name="salesRepresentativeCode"
              onChange={this.onChange}
              value={criteria.salesRepresentativeCode}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>From Picked Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromInvoiceDate"
              onChange={this.onChange}
              value={criteria.fromInvoiceDate}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>To Picked Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toInvoiceDate"
              onChange={this.onChange}
              value={criteria.toInvoiceDate}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

function InvoicedAndNotApprovedListInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <InvoicedAndNotApprovedList {...props} name="" /> <br />
    </div>
  );
}

export default InvoicedAndNotApprovedListInquiry;
